import React, { useMemo, useState } from "react";
import {
  type MRT_ColumnDef,
} from "material-react-table";
import { useTheme } from "@mui/material";
import { AdminGlobalTable } from "../../../tables/AdminGlobalTable";
import { AllRoleCell } from "../../common/RoleUtils";

export type TOrgUser = {
  roleID: string;
  roleName: string;
  groupID: string;
  groupType: string;
  groupName: string;
  name: string;
  userID: string;
};

const orgUsersRoleCol = [
  { header: "Name", accessorKey: "name", enableEditing: false,},
  { header: "Group Type", accessorKey: "groupType",enableEditing: false, },
  { header: "Group Name", accessorKey: "groupName",enableEditing: false, },
  {
    header: "Role",
    accessorKey: "roleName",
    Cell: AllRoleCell,
  },
];

const OrgUsersRoleTable = ({ row }) => {
  const theme = useTheme();
  const columns = useMemo<MRT_ColumnDef<TOrgUser>[]>(() => orgUsersRoleCol, []);
  
  const getSubRows = (item) =>
    item?.roles?.map((role) => ({
      ...role,
      name: item?.name,
      userID:item?.userID
    }));

  return (
    <>
      <AdminGlobalTable
        columns={columns}
        data={getSubRows(row.original)}
        config={{
          enableGlobalFilter: false,
          enableDensityToggle: false,
          enablePagination: false,
          
          muiTableBodyRowProps: () => ({
            hover: false,
            sx: {
              backgroundColor: "transparent",
              ":hover": { backgroundColor: theme?.custom?.hoverOptionColor },
            },
          }),
          renderTopToolbar: () => {
            return <></>;
          },
        }}
      />
    </>
  );
};

export default OrgUsersRoleTable;
